import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from "../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter";
import {PaymentRequestReminderModel} from "../../api/entity/paymentRequestReminder.model";
import {PaymentRequestReminderConverter} from "../../api/entity/converter/paymentRequestReminder.converter";
import {PaymentRequestReminderDataService} from "./paymentRequestReminderData.service";

@Injectable()
export class PaymentRequestReminderDataServiceAdapter extends AbstractDataServiceDtoAdapter<PaymentRequestReminderModel, PaymentRequestReminderConverter> {
    constructor(dataService: PaymentRequestReminderDataService, converter: PaymentRequestReminderConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): PaymentRequestReminderModel {
        return new PaymentRequestReminderModel();
    }


}
